// adminportal/src/utils/api.ts
import { getConfig } from '../config';
import { CognitoAuthService } from '../services/cognitoAuth';

// Get API base URL with trailing slash removed
export function getApiBaseUrl(): string {
  const config = getConfig();
  const apiBaseUrl = config.apiUrl;
  if (!apiBaseUrl || apiBaseUrl.includes('placeholder.invalid')) {
    // Return placeholder to allow graceful error handling in components
    return 'https://placeholder.invalid/api';
  }
  // Remove trailing slash to avoid double slashes when concatenating
  return apiBaseUrl.replace(/\/$/, '');
}

// Build full API URL for a specific endpoint
export function buildApiUrl(endpoint: string): string {
  const baseUrl = getApiBaseUrl();
  // Ensure endpoint starts with / but don't add trailing slash
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
}

// Make an authenticated API call
export async function authenticatedFetch(
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> {
  const url = buildApiUrl(endpoint);
  const accessToken = CognitoAuthService.getAccessToken();

  if (!accessToken) {
    throw new Error('No access token available. Please log in again.');
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  };

  // Add any custom headers from options
  if (options.headers) {
    Object.entries(options.headers).forEach(([key, value]) => {
      if (typeof value === 'string') {
        headers[key] = value;
      }
    });
  }

  // Only set Content-Type to application/json if not already set and body is not FormData
  if (!headers['Content-Type'] && !headers['content-type'] && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
